var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("img", {
      class: { active: _vm.currentIndex == _vm.additionalImage.index },
      attrs: { src: _vm.additionalImage.thumbnail, alt: "" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }